import styles from './FooterSecondaryNavTablet.scss';

import React, { FC } from 'react';

import { ExternalLink, InternalLink, LinkSet } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'src/components/Grid/Grid';
import { FlatEntry } from 'src/services/cms/flattenContentful';

import { TermsAndConditions } from '../../TermsAndConditions/TermsAndConditions';
import { FooterLegalLinks } from '../FooterLegalLinks/FooterLegalLinks';
import { FooterLocalePicker } from '../FooterLocalePicker/FooterLocalePicker';
import { FooterSocialLinks } from '../FooterSocialLinks/FooterSocialLinks';
import { FooterSecondaryNavTabletColumn } from './FooterSecondaryNavTabletColumn';

export const columnIndexes = [0, 1, 2];

export interface FooterSecondaryNavTabletProps {
  items?: Array<FlatEntry<LinkSet>>;
  legalLinks?: Array<FlatEntry<ExternalLink | InternalLink>>;
  socialLinks?: Array<FlatEntry<ExternalLink>>;
  isVisible: boolean;
}

export const FooterSecondaryNavTablet: FC<FooterSecondaryNavTabletProps> = ({
  items = [],
  legalLinks = [],
  socialLinks = [],
  isVisible,
}) => {
  const gridSize = isVisible ? 12 : 9;
  return (
    <Grid item xs={12} className={styles.footerSecondaryNavTablet}>
      <Grid container justifyContent="center" className={styles.container}>
        {!!items.length && (
          <Grid item xs={gridSize} container gutter>
            {columnIndexes.map(columnIndex => (
              <FooterSecondaryNavTabletColumn
                key={columnIndex}
                items={items}
                columnIndex={columnIndex}
              />
            ))}
          </Grid>
        )}
        {!!socialLinks.length && (
          <Grid item xs={gridSize}>
            <FooterSocialLinks items={socialLinks} className={styles.socialLinks} />
          </Grid>
        )}
        {!!(items.length + socialLinks.length) && (
          <Grid item xs={gridSize}>
            <div className={styles.footerTabletBorder} />
          </Grid>
        )}
        <Grid item xs={gridSize} container gutter>
          <TermsAndConditions className={styles.disclosureBlurbWrapper} />
        </Grid>
        <Grid item xs={gridSize} container gutter className={styles.legalLinks}>
          <Grid item xs>
            <FooterLegalLinks items={legalLinks} isList />
          </Grid>
          <Grid item xs={5} lg="auto">
            <FooterLocalePicker className={styles.localePicker} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FooterSecondaryNavTablet.displayName = 'FooterSecondaryNavTablet';
